exports = module.exports = require("../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".reopencomplaint-field {\n  background-color: #ffffff;\n  padding-top: 16px !important;\n  height: calc(100vh - 64px); }\n\n.reopencomplaint-textArea {\n  padding: 24px 16px 0px 1px; }\n\n.reopencomplaint-upload-photo {\n  margin-top: 28px; }\n\n.reopencomplaint-button {\n  padding: 8px !important;\n  position: fixed !important;\n  left: 0px;\n  bottom: 60px;\n  width: 100%;\n  background-color: #ffffff; }\n\n.reopencomplaint-question {\n  padding-top: 12px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/ReOpenComplaint/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/pgr/ReOpenComplaint/index.css
// module chunks = 504